import SettingsIcon from '@mui/icons-material/Settings'
import NotificationConfigurationsList from './NotificationConfigurations.list'
import NotificationConfigurationsCreate from './NotificationConfigurations.create'
import NotificationConfigurationsEdit from './NotificationConfigurations.edit'

const resource = {
  list: NotificationConfigurationsList,
  create: NotificationConfigurationsCreate,
  edit: NotificationConfigurationsEdit,
  icon: SettingsIcon,
}

export default resource
